module.exports = __webpack_public_path__ + "static/media/profile.ea84914d.jpg";